/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grandfather_WarningInputs */

const en_grandfather_warning = /** @type {(inputs: Grandfather_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To gracefully edit a live tier offering with active subscribers, hide this listing and create a new one to protect their original purchase.`)
};

const es_grandfather_warning = /** @type {(inputs: Grandfather_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para editar de forma segura una oferta activa con suscriptores, oculta este anuncio y crea uno nuevo para proteger la compra original de tus usuarios.`)
};

const fr_grandfather_warning = /** @type {(inputs: Grandfather_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour modifier de manière élégante une offre en direct avec des abonnés actifs, masquez cette annonce et créez-en une nouvelle pour protéger leur achat initial.`)
};

const de_grandfather_warning = /** @type {(inputs: Grandfather_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um ein aktives Stufenangebot mit Abonnenten sicher zu bearbeiten, verberge dieses Inserat und erstelle ein neues.`)
};

const id_grandfather_warning = /** @type {(inputs: Grandfather_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk mengedit tingkat penawaran live dengan aman yang sudah memiliki pelanggan aktif, sembunyikan listing ini dan buat yang baru untuk melindungi pembelian asli mereka.`)
};

/** @type {(inputs: Grandfather_WarningInputs) => LocalizedString} */
const ja_grandfather_warning = en_grandfather_warning;

/** @type {(inputs: Grandfather_WarningInputs) => LocalizedString} */
const zh_grandfather_warning = en_grandfather_warning;

/** @type {(inputs: Grandfather_WarningInputs) => LocalizedString} */
const ar_grandfather_warning = en_grandfather_warning;

/** @type {(inputs: Grandfather_WarningInputs) => LocalizedString} */
const it_grandfather_warning = en_grandfather_warning;

/** @type {(inputs: Grandfather_WarningInputs) => LocalizedString} */
const ru_grandfather_warning = en_grandfather_warning;

/** @type {(inputs: Grandfather_WarningInputs) => LocalizedString} */
const pt_grandfather_warning = en_grandfather_warning;

/** @type {(inputs: Grandfather_WarningInputs) => LocalizedString} */
const ko_grandfather_warning = en_grandfather_warning;

/**
* | output |
* | --- |
* | "To gracefully edit a live tier offering with active subscribers, hide this listing and create a new one to protect their original purchase." |
*
* @param {Grandfather_WarningInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const grandfather_warning = /** @type {((inputs?: Grandfather_WarningInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grandfather_WarningInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_grandfather_warning(inputs)
	if (locale === "es") return es_grandfather_warning(inputs)
	if (locale === "fr") return fr_grandfather_warning(inputs)
	if (locale === "de") return de_grandfather_warning(inputs)
	if (locale === "ja") return ja_grandfather_warning(inputs)
	if (locale === "zh") return zh_grandfather_warning(inputs)
	if (locale === "ar") return ar_grandfather_warning(inputs)
	if (locale === "id") return id_grandfather_warning(inputs)
	if (locale === "it") return it_grandfather_warning(inputs)
	if (locale === "ru") return ru_grandfather_warning(inputs)
	if (locale === "pt") return pt_grandfather_warning(inputs)
	return ko_grandfather_warning(inputs)
});